import { ZoneContextManager } from "@opentelemetry/context-zone";
import { W3CTraceContextPropagator } from '@opentelemetry/core';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { FetchInstrumentation } from "@opentelemetry/instrumentation-fetch";
import { XMLHttpRequestInstrumentation } from "@opentelemetry/instrumentation-xml-http-request";
import { Resource } from '@opentelemetry/resources';
import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { SEMRESATTRS_SERVICE_NAME, SEMRESATTRS_SERVICE_VERSION } from "@opentelemetry/semantic-conventions";
import { Config } from "../config";
import { withFaro } from "./faro";

export const oTelTracer = (config: Config) => {
    console.debug("Attaching Open telemetry tracer...")
    const resource = Resource.default().merge(
        new Resource({
            [SEMRESATTRS_SERVICE_NAME]: config.tracer_name,
            [SEMRESATTRS_SERVICE_VERSION]: config.version,
        })
    );

    const ignoreUrls = []
    const provider = new WebTracerProvider({ resource })

    const [_, ignoreUrl] = withFaro(provider, config);
    if (ignoreUrl) ignoreUrls.push(ignoreUrl);

   
    provider.register({
        propagator: new W3CTraceContextPropagator(),
        contextManager: new ZoneContextManager(),
    });

    registerInstrumentations({
        instrumentations: [
            new FetchInstrumentation({ ignoreUrls }),
            new XMLHttpRequestInstrumentation({ ignoreUrls, enabled: true, }),
        ]
    })
}
